/**
 * Arrows for the testimonials section: scroll the track by one card and disable an arrow
 * at either end. The track itself is a native scroll-snap list, so swiping and keyboard
 * scrolling work without this script.
 */
if (!customElements.get('testimonials-track')) {
  customElements.define(
    'testimonials-track',
    class TestimonialsTrack extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.tst__track');
        this.arrows = Array.from(this.querySelectorAll('.tst__arrow'));
        if (!this.track || this.arrows.length === 0) return;

        this.onArrowClick = this.onArrowClick.bind(this);
        this.updateArrows = this.updateArrows.bind(this);
        this.arrows.forEach((arrow) => arrow.addEventListener('click', this.onArrowClick));
        this.track.addEventListener('scroll', this.updateArrows, { passive: true });
        window.addEventListener('resize', this.updateArrows, { passive: true });
        this.updateArrows();
      }

      disconnectedCallback() {
        if (!this.track) return;
        this.arrows.forEach((arrow) => arrow.removeEventListener('click', this.onArrowClick));
        this.track.removeEventListener('scroll', this.updateArrows);
        window.removeEventListener('resize', this.updateArrows);
      }

      onArrowClick(event) {
        const direction = Number(event.currentTarget.dataset.direction) || 1;
        const card = this.track.querySelector('.tst__card');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: direction * step, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      updateArrows() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;
        this.arrows.forEach((arrow) => {
          const direction = Number(arrow.dataset.direction);
          arrow.disabled = direction < 0 ? this.track.scrollLeft <= 2 : this.track.scrollLeft >= maxScroll;
        });
      }
    }
  );
}
